import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import styles from './SharedLookLimitButton.styles';
import SharedLookLimitButton from './SharedLookLimitButton';

export default compose(withStyles(styles))(SharedLookLimitButton);
